var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingFacilitiesl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 21V5C4 3.89543 4.76751 3 5.71429 3H14.2857C15.2325 3 16 3.89543 16 5V21",
    fill: "#CED0DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 21V7.66667C7 6.74619 7.76751 6 8.71429 6H17.2857C18.2325 6 19 6.74619 19 7.66667V21",
    fill: "#E3E4E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H21",
    stroke: "#202E5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.6875V16.9375C11.1333 16.625 11.72 16 13 16C14.28 16 14.8667 16.625 15 16.9375V21",
    stroke: "#202E5F",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#202E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingFacilitiesl);
export default __webpack_public_path__ + "static/media/building-facilitiesl.e0efbbe81520d62440c15a8ef1d8a582.svg";
export { ForwardRef as ReactComponent };